import { isNil as _isNil, toString as _toString } from 'lodash';

export default (val: string): string => {
    if (_isNil(val)) {
        return val;
    }

    return _toString(val);
};
